import {Component, computed, inject, output, signal} from '@angular/core';
import {Alert} from '../../../../shared/components/alert/alert';
import {ButtonComponent} from '../../../../shared/components/button/button.component';
import {SelectionStore} from '../../selection.store';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Form} from '../../../../shared/components/form/form';
import {SignaturePadComponent} from '../../../../shared/components/signature-pad/signature-pad.component';

@Component({
  selector: 'app-selection-footer',
  imports: [
    Alert,
    ButtonComponent,
    FormsModule,
    ReactiveFormsModule,
    Form,
    SignaturePadComponent,
    SignaturePadComponent
  ],
  templateUrl: './selection-footer.component.html',
  styleUrl: './selection-footer.component.css'
})
export class SelectionFooterComponent {
  onsubmit = output<string>();

  signature = signal('');

  private selectionStore = inject(SelectionStore);

  disabled = computed(() => !this.selectionStore.selected() || this.selectionStore.isSubmitFulfilled() || this.selectionStore.isSubmitPending());
  buttonDisabled = computed(() => this.disabled() || !this.signature().length);

  submit() {
    if (this.signature()) {
      this.onsubmit.emit(this.signature());
    }
  }
}
